<template>
  <div class="new-oil-card-body">
    <div class="new-oil-card-nav">
      <navbar title="油卡管理" :lefticonshow="true" :lefticonwidth="9" :lefticonheight='16' :lefticon="newoilcardbackicon" :righticonshow="true" :righticon="newoilcardrighticon" :righticonheight="16" :righticonwidth="16" @goback="goBack" @rightclick="goPage('/new-oli/cardbind')">
        <template v-slot:navheaderbottom>
          <div class="oil-card-tag-div">
            <div class="oil-tag-item" :class="{'oil-tag-actiave':oil_type=='sinopec'}" @click="changeOilType('sinopec')">中国石化 ({{sinopec_total}})</div>
            <div class="oil-tag-item" :class="{'oil-tag-actiave':oil_type=='cnpc'}" @click="changeOilType('cnpc')">中国石油 ({{cnpc_total}})</div>
          </div>
        </template>
      </navbar>
    </div>
    <div class="new-oil-card-second-div">
      <div v-show="oil_type=='sinopec'">
        <van-list v-model="sinopec_card_loading" :finished="sinopec_card_finished" finished-text="" :immediate-check="false" @load="sinopecOnLoad">
          <div class="oli-card-item" v-for="(item,index) in sinopec_oil_card_list" :key="index" @click="goPage('/new-oli/recharge',item)">
            <img class="oli-card-bg" :src="chinasinopeccardbg" alt="">
            <div class="oli-card-con">
              <div class="card-first-div">
                <div>
                  <img class="oli-card-logo" :src="chinasinopeclogo" alt="">
                  <span class="oli-card-name">中国石化加油卡</span>
                </div>
                <div>
                  <span class="oli-card-nickname">{{item.remark}}</span>
                  <span class="oli-card-setting" @click.stop="more_control_show=!more_control_show;edit_index=index"><img :src="oilcardmoreicon" alt=""></span>
                </div>
              </div>
              <div class="card-second-div">
                <div class="oil-tag">Card number</div>
                <div class="oil-number">{{HandlecardNumber(item.gas_card_number)}}</div>
              </div>
              <div class="card-control-div" v-show="more_control_show && edit_index ==index">
                <div class="control-item" @click.stop="gas_card_number=item.gas_card_number;editPupShow=true;more_control_show=false;">备注</div>
                <div class="control-item" @click.stop="readyDeleteCard(item.gas_card_number)">解绑</div>
              </div>
            </div>
          </div>
        </van-list>
        <div class="oil-card-empty" v-if="sinopec_oil_card_list.length==0 && !page_loading"><img :src="newoilcardemptyicon" alt=""></div>
      </div>
      <div v-show="oil_type=='cnpc'">
        <van-list v-model="cnpc_card_loading" :finished="cnpc_card_finished" finished-text="" :immediate-check="false" @load="cnpcOnLoad">
          <div class="oli-card-item" v-for="(item,index) in cnpc_oil_card_list" :key="index" @click="goPage('/new-oli/recharge',item)">
            <img class="oli-card-bg" :src="chinapetroleumcardbg" alt="">
            <div class="oli-card-con">
              <div class="card-first-div">
                <div>
                  <img class="oli-card-logo" :src="chinapetroleumlogo" alt="">
                  <span class="oli-card-name">中国石油加油卡</span>
                </div>
                <div>
                  <span class="oli-card-nickname">{{item.remark}}</span>
                  <span class="oli-card-setting" @click.stop="more_control_show=!more_control_show;edit_index=index"><img :src="oilcardmoreicon" alt=""></span>
                </div>
              </div>
              <div class="card-second-div">
                <div class="oil-tag">Card number</div>
                <div class="oil-number">{{HandlecardNumber(item.gas_card_number)}}</div>
              </div>
              <div class="card-control-div" v-show="more_control_show && edit_index==index">
                <div class="control-item" @click.stop="gas_card_number=item.gas_card_number;editPupShow=true;more_control_show=false;">备注</div>
                <div class="control-item" @click.stop="readyDeleteCard(item.gas_card_number)">解绑</div>
              </div>
            </div>
          </div>
        </van-list>
        <div class="oil-card-empty" v-if="cnpc_oil_card_list.length==0 && !page_loading"><img :src="newoilcardemptyicon" alt=""></div>
      </div>
    </div>
    <commonpup :show="untiePupShow" title="是否确认解绑？" pupcancelText="取消" pupcertainText="确认解绑" pupcertainColor="#F9720E" @cancel="untiePupShow=false" @certain="deleteCard" />
    <commonpup :show="editPupShow" pupcancelText="取消" pupcertainText="确认修改" pupcertainColor="#F9720E" @cancel="editPupShow=false" @certain="editCard">
      <template v-slot:pup-center>
        <div class="card-pup-remark">
          <span>备注：</span>
          <span>
            <commoninput :value.sync="remark" placeholder="请在此输入您的油卡备注名称" :maxLength="5" /></span>
        </div>
      </template>
    </commonpup>
    <centerrscreenloading :loading="page_loading" />
  </div>
</template>

<script>
  import navbar from '../components/nav-bar.vue'
  import commonpup from '../components/common-pup.vue'
  import commoninput from '../components/common-input.vue'
  import centerrscreenloading from '../components/centerrscreen-loading.vue'
  import { getThirdrechargeOilBindList, makeThirdrechargeOilCardRemark, deleteThirdrechargeOilCard } from '../api/index'
  import { Toast } from 'vant'
  export default {
    components: { navbar, commonpup, commoninput, centerrscreenloading },
    data() {
      return {
        newoilcardbackicon: require('@/assets/recharge/new-oilcard-back-icon.png'),
        newoilcardrighticon: require('@/assets/recharge/new-oilcard-right-icon.png'),
        chinapetroleumcardbg: require('@/assets/recharge/china-petroleum-card-bg.png'),
        chinapetroleumlogo: require('@/assets/recharge/china-petroleum-logo.png'),
        chinasinopeccardbg: require('@/assets/recharge/china-sinopec-card-bg.png'),
        chinasinopeclogo: require('@/assets/recharge/china-sinopec-logo.png'),
        oilcardmoreicon: require('@/assets/recharge/oil-card-more-icon.png'),
        newoilcardemptyicon: require('@/assets/recharge/new-oilcard-empty-icon.png'),
        oil_type: 'sinopec',
        more_control_show: false,
        untiePupShow: false,
        remark: '',
        gas_card_number: '',
        sinopec_oil_card_list: [],
        cnpc_oil_card_list: [],
        page_loading: true,
        edit_index: -1,
        editPupShow: false,
        sinopec_card_loading: false,
        sinopec_card_finished: false,
        cnpc_card_loading: false,
        cnpc_card_finished: false,
        sinopec_page: 1,
        cnpc_page: 1,
        pagesize: 5,
        sinopec_total: 0,
        cnpc_total: 0
      }
    },
    async created() {
      await this.getOilCardDate('sinopec', this.sinopec_page)
      await this.getOilCardDate('cnpc', this.cnpc_page)
      this.page_loading = false
    },
    methods: {
      async sinopecOnLoad() {
        this.sinopec_page += 1
        await this.getOilCardDate(this.oil_type, this.sinopec_page)
      },
      async cnpcOnLoad() {
        this.cnpc_page += 1
        await this.getOilCardDate(this.oil_type, this.cnpc_page)
      },
      changeOilType(name) {
        this.oil_type = name
        this.edit_index = -1
        this.more_control_show = false
        // this.getOilCardDate(this.oil_type)
      },
      editCard() {
        if (this.remark.length > 6) {
          return Toast('请输入5位字符以内的备注')
        }
        this.editPupShow = false
        if (this.remark.length == 0) {
          return
        }
        makeThirdrechargeOilCardRemark({ gasCardNo: this.gas_card_number, remark: this.remark }).then((res) => {
          if (res.list == 1) {
            Toast('修改成功')
            this.remark = ''
            if (this.oil_type == 'sinopec') {
              this.sinopec_page = 1
              this.sinopec_card_finished = false
            } else {
              this.cnpc_page = 1
              this.cnpc_card_finished = false
            }
            this.getOilCardDate(this.oil_type, 1)
          }
        }).catch(() => {
          this.page_loading = false
        })
      },
      async getOilCardDate(oil_type, page) {
        this.page_loading = true
        await getThirdrechargeOilBindList({ oil_type, page, pageSize: this.pagesize }).then((res) => {
          if (oil_type == 'sinopec') {
            this.sinopec_card_loading = false
            this.sinopec_total = res.list.total
            if (page == 1) {
              this.sinopec_oil_card_list = res.list.data
            } else {
              this.sinopec_oil_card_list = this.sinopec_oil_card_list.concat(res.list.data)
            }
            if (res.list.data.length < this.pagesize) {
              this.sinopec_card_finished = true
            }
          } else {
            this.cnpc_total = res.list.total
            if (page == 1) {
              this.cnpc_oil_card_list = res.list.data
            } else {
              this.cnpc_oil_card_list = this.cnpc_oil_card_list.concat(res.list.data)
            }
            if (res.list.data.length < this.pagesize) {
              this.cnpc_card_finished = true
            }
            this.cnpc_card_loading = false
          }
        }).catch(() => {
          // this.page_loading = false
        }).finally(() => {
          this.page_loading = false
        })
      },
      readyDeleteCard(gas_card_number) {
        this.untiePupShow = true;
        this.more_control_show = false;
        this.gas_card_number = gas_card_number
      },
      deleteCard() {
        deleteThirdrechargeOilCard({ gasCardNo: this.gas_card_number }).then(async (res) => {
          if (res.list == 1 || res.list == 2) {
            Toast('解绑成功')
            if (this.oil_type == 'sinopec') {
              this.sinopec_page = 1
              this.sinopec_card_finished = false
            } else {
              this.cnpc_page = 1
              this.cnpc_card_finished = false
            }
            this.untiePupShow = false
            await this.getOilCardDate(this.oil_type, 1)
            if (this.sinopec_total + this.cnpc_total == 0) {
              this.$router.replace('/new-oli/cardbind?back_to=rechargeHome')
            }
          }
        })
      },
      HandlecardNumber(number) {
        let new_number = ''
        for (let index in number) {
          new_number += number[index]
          if (index % 4 == 3) {
            new_number += ' '
          }
        }
        return new_number
      },
      goPage(path, item) {
        if (path == '/new-oli/recharge') {
          this.$router.replace({
            path,
            query: {
              card_id: item.id
            }
          })
        } else {
          this.$router.push({
            path
          })
        }

      },
      goBack() {
        this.$router.go(-1)
      }
    }
  }
</script>
<style lang="less">
  .new-oil-card-body {
    .card-pup-remark {
      .common-input {
        input {
          //     // width: 100px;
          padding-left: 2px;

          //     &::first-line {
          //     }
        }


        //   @supports (-webkit-mask: none) and (not (caret-color: red)) {
        //     input::first-line {
        //     }
        //   }
      }
    }
  }
</style>
<style lang="less" scoped>
  .new-oil-card-body {
    padding-top: 128px;
    min-height: calc(100vh - 128px);
    background: rgba(0, 0, 0, 0.03);

    .new-oil-card-nav {
      padding-top: 44px;
      position: fixed;
      top: 0;
      left: 0;
      background: #fff;
      z-index: 9;

      .oil-card-tag-div {
        height: 44px;
        display: flex;

        .oil-tag-item {
          flex: 1;
          font-size: 14px;
          font-weight: 400;
          text-align: left;
          color: #333333;
          line-height: 44px;
          text-align: center;
        }

        .oil-tag-actiave {
          color: #F9720E;
          position: relative;

          &::after {
            content: '';
            width: 84px;
            height: 4px;
            background: linear-gradient(135deg, #f9750d, #f44e19);
            border-radius: 2px;
            position: absolute;
            left: 50%;
            bottom: 0;
            transform: translateX(-50%);
          }
        }
      }
    }

    .new-oil-card-second-div {
      margin-top: 16px;
      padding: 0 16px 16px;

      .oli-card-item {
        height: 154px;
        position: relative;
        margin-bottom: 14px;

        .oli-card-bg {
          position: absolute;
          left: 0;
          top: 0;
          height: 154px;
          width: 100%;
          z-index: 1;
        }

        .oli-card-con {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          z-index: 2;

          .card-first-div {
            padding: 18px 17px 40px 9px;
            display: flex;
            justify-content: space-between;
            height: 26px;
            position: relative;

            .oli-card-logo {
              width: 25px;
              height: 26px;
              margin-right: 9px;
            }

            .oli-card-name {
              font-size: 14px;
              font-weight: 500;
              text-align: left;
              color: #ffffff;
              line-height: 20px;
              letter-spacing: 1.1px;
              text-shadow: 1px 0px 0px 0px #f5621c;
              margin-top: 3px;
              display: inline-block;
              vertical-align: top;
            }

            .oli-card-nickname {
              display: inline-block;
              vertical-align: top;
              margin-top: 5px;
              font-size: 12px;
              font-weight: 400;
              text-align: right;
              color: #ffffff;
              line-height: 17px;
              margin-right: 4px;
            }

            .oli-card-setting {
              display: inline-block;
              width: 24px;
              height: 100%;
              text-align: center;
              margin-right: -2px;

              img {
                width: 16px;
                height: 4px;
              }
            }
          }

          .card-second-div {
            padding-left: 9px;

            .oil-tag {
              opacity: 0.6;
              font-size: 10px;
              font-weight: 400;
              text-align: left;
              color: #ffffff;
              line-height: 12px;
              letter-spacing: 0.33px;
              margin-bottom: 3px;
            }

            .oil-number {
              font-size: 18px;
              font-weight: 600;
              text-align: left;
              color: #ffffff;
              line-height: 25px;
              letter-spacing: 0.59px;
            }
          }

          .card-control-div {
            position: absolute;
            z-index: 1;
            border-radius: 6px;
            background: #fff;
            right: 0px;
            top: 44px;

            .control-item {
              opacity: 0.8;
              font-size: 12px;
              font-weight: 400;
              text-align: left;
              color: #333333;
              line-height: 17px;
              letter-spacing: 0.39px;
              padding: 8px 18px;
            }
          }
        }
      }

      .oil-card-empty {
        text-align: center;

        img {
          width: 228px;
          height: 247px;
          margin: 140px auto 0;
        }
      }
    }

    .bm34 {
      bottom: 67px;
    }

    .card-pup-remark {
      width: calc(100% - 100px);
      margin: auto;
      padding: 31px 0 29px;
      display: flex;

      span {
        vertical-align: top;

        &:first-child {
          font-size: 16px;
          font-weight: 400;
          text-align: left;
          color: #333333;
          line-height: 22px;
          letter-spacing: 0.52px;
          width: auto;
          white-space: nowrap;
        }
      }
    }
  }
</style>